import api from "../../../api/axios";

// Feature-local wrapper for the Client list used by the cross-screen
// consistency screen (Phase 17).
//
// Endpoint (per backend/app/apps/clients/views.py ClientViewSet):
//   GET /api/crm/clients/   — IsAuthenticated, owner OR shared.
//        Returns ClientListSerializer payloads including list aggregates:
//        preferences, last_communication_at, matches_count,
//        new_matches_count, open_tasks_count (CRM-WORKFLOW-B1).
//        by -created_at server-side. Supports ClientFilter / search
//        / ordering query params, but Phase 17 intentionally
//        consumes NONE of them — no filters, no search, no sorting
//        per brief Step 9.
//
// The DRF endpoint may or may not be paginated depending on global
// settings; the consumer reads `Array.isArray(data) ? data : data.results`
// defensively. Phase 17 does NOT add pagination UI either way.
//
// Stateless request wrapper. No cache. No retry. No invalidation.
// Not a repository, not an entity service, not a resource manager,
// not a synchronization surface — per Phase 17 brief Step 2.

export const fetchClients = (params) =>
  api.get("/crm/clients/", { params }).then((res) => res.data);

// CL-5 client-creation transport.
//
// Endpoint (per backend/app/apps/clients/views.py ClientViewSet):
//   POST /api/crm/clients/   — IsAuthenticated. Serializer:
//     ClientWriteSerializer (first_name, last_name, phone, email,
//     type, status, source, notes). Owner is set server-side via
//     ClientViewSet.perform_create (serializer.save(owner=request.user)).
//   Backend uniqueness constraint: (owner, phone) — DRF surfaces a
//     400 with `phone: [...]` on duplicate. parseDrfFieldErrors
//     routes that to the phone field.
//   Response: 201 with the ClientWriteSerializer payload of the
//     freshly-created row.
//
// Stateless POST wrapper. No optimistic insertion. No cache.
// Post-success refresh is owned by the parent
// (ClientsListScreenContent.handleReload()).
export const createClient = (body) =>
  api.post("/crm/clients/", body).then((res) => res.data);
